import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { type RootState, useAppDispatch } from '../../../../configuration/setup/store';
import { useTrackingAttributes } from '../../common/utils/googleTagManagerAttributes';
import { getAvailableResources } from '../resourceSelection/redux/resourceSelection.redux';
import { fetchBookableResourcesThunk } from '../resourceSelection/resourceSelection.thunk';

export const MANEulaConsentRequiredHint = () => {
    const availableResources = useSelector((state: RootState) => getAvailableResources(state));
    const dispatch = useAppDispatch();
    const trackingAttributesVisible = useTrackingAttributes('manEULAHint', 'visibility');

    // Check if we have at least one resource that is not bookable due to missing MAN EULA consent
    if (!availableResources.some(resource => resource.missingManEulaConsent)) {
        return null;
    }

    const handleReloadResources = () => {
        dispatch(fetchBookableResourcesThunk);
    };

    return (
        <div
            className='alert alert-warning margin-bottom-15 display-flex justify-space-between align-items-start'
            {...trackingAttributesVisible}
        >
            <div className='display-flex gap-10'>
                <span className='text-color-warning text-size-h4 rioglyph rioglyph-exclamation-sign' />
                <div>
                    <strong className='text-size-16'>
                        <FormattedMessage id='marketplace.checkout.missingMANEulaConsent.headline' />
                    </strong>
                    <div className='margin-y-5'>
                        <FormattedMessage
                            id='marketplace.checkout.missingMANEulaConsent'
                            values={{
                                link: chunks => (
                                    <a
                                        href='https://man-eula.iam.rio.cloud/'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        className='alert-link'
                                    >
                                        {chunks}
                                    </a>
                                ),
                            }}
                        />
                    </div>
                </div>
            </div>
            <Button
                type='button'
                className='btn btn-xs btn-action btn-icon-only flex-0'
                onClick={handleReloadResources}
            >
                <span className='rioglyph rioglyph-refresh' aria-hidden='true' />
            </Button>
        </div>
    );
};
